export default __webpack_public_path__ + "static/media/png.6dfda39d.svg";